import { directive as onClickaway } from 'vue-clickaway';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import lessonSidebar from '../../components/lesson-sidebar/index.vue';
import { seo } from '@/mixins/seo';
import donate from '@/components/features/donate/index.vue';

export default {
	name		: 'courses-lesson', 
	mixins		: [seo], 
	directives	: {
		onClickaway: onClickaway,
	}, 
	props		: {}, 
	components	: {
		lessonSidebar
		//donate
	}, 
	data() {
		return {
			active: false, value: '', heightHeader: 0, heightFooter: 0, position: {
				left: 0, bottom: 30
			}
		}
	}, 
	created() {
		this.fetchLesson({
			item		: this.$route.params.item,
			moduleSlug	: this.$route.params.moduleSlug,
			lessonSlug	: this.$route.params.lessonSlug
		})
		.then(() => {
			this.fetchStudentsList(this.lesson.course.data);
			
			if (window.innerWidth > 980 && this.$route.name === 'courses-lesson-detail') {
				this.init();
				
				window.addEventListener('scroll', this.handleScroll, true)
				window.addEventListener('resize', this.setPositionSidebar, true)
			}
		})
		.catch(error => {
			console.log('error:');
			console.log(error);
			console.log('');
			
			console.log('response:');
			console.log(error.response);
			console.log('');
			
			if (error.response && error.response.status === 403) {
				// this.$toasted.error(error.response.data.error.message_key);
				if (error.response.data.error.code === 'course-122') {
					this.$router.push({
						name: 'courses-dashboard'
					})
				}
			}else if(!error.response){
				this.$router.push({
					name: 'courses-dashboard'
				})
			}
		})
	},
	mounted() {
	},
	computed: {
		...mapGetters({
			lesson: 'coursesLesson/lesson', isLoading: 'coursesLesson/isLoading', module: 'coursesLesson/module',
		}),
	},
	methods: {
		...mapActions({
			fetchLesson: 'coursesLesson/FETCH_LESSON', fetchStudentsList: 'coursesWidgets/FETCH_STUDENTS_LIST'
		}),
		...mapMutations({
			setLesson: 'coursesLesson/SET_CURRENT_ITEM', setModule: 'coursesLesson/SET_MODULE'
		}),
		init() {
			if (!document) return;
			this.heightHeader = document.querySelector('.header-wrap')?.clientHeight || 52;
			this.heightFooter = document.querySelector('.footer')?.clientHeight || 68;
			
			this.setPositionSidebar()
		},
		setPositionSidebar() {
			this.position.left = document.querySelector('.courses-lesson__sidebar').offsetLeft + document.querySelector('.education-wrap').offsetLeft
		},
		handleScroll(e) {
			const h = document.documentElement, st = 'scrollTop'
			const scrolled = (h[st]);
			
			const bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - this.heightFooter;
			if (bottomOfWindow) {
				if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
					this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30 + 220
				} else {
					this.position.bottom = Math.abs(((document.documentElement.offsetHeight) - (document.documentElement.scrollTop + window.innerHeight)) - this.heightFooter) + 30
				}
			} else {
				if (document.querySelector('.video-providers') && document.querySelector('.video-providers').classList.contains('fixed')) {
					this.position.bottom = 250
				} else this.position.bottom = 30
			}
		},
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
		window.removeEventListener('resize', this.setPositionSidebar)
		
		this.setModule(null);
		this.setLesson(null);
	}
}
